import { Row, Input, Col, Button, Space, Divider, notification } from "antd";
import {
  BorderBottomOutlined,
  BorderTopOutlined,
  RadiusBottomleftOutlined,
  RadiusBottomrightOutlined,
  RadiusUpleftOutlined,
  RadiusUprightOutlined,
} from "@ant-design/icons";
import { useEffect } from "react";
import { useState } from "react";
import { ParamsControlService } from "../../../../../services/paramscontrol";

function ModalParams({ data, refreshParent }) {

  const [api, contextHolder] = notification.useNotification();
  const [loading, setLoading] = useState(false);
  const openNotificationWithIcon = (type) => {
    api[type]({
      message: "Sucesso",
      description: "As informações do parâmetro foram salvas com êxito!",
    });
  };
  const [valor, setValor] = useState("");
  const [nome, setNome] = useState("");
  const [messageError, setMessageError] = useState("");
  const [empresa, setEmpresa] = useState("");
  const [filialp, setFilialp] = useState("");
  const [tipo, setTipo] = useState("");
  const [descricao, setDescricao] = useState("");
  const [descricao_esp, setDescricao_esp] = useState("");
  const [descricao_en, setDescricao_en] = useState("");
  const [valor_esp, Setvalor_esp] = useState("");
  const [valor_eng, setValor_eng] = useState("");

  useEffect(() => {
    if (data) {
      setValor(data.detail[0].valor);
      setTipo(data.detail[0].tipo);
      setDescricao(data.detail[0].descricao);
      setDescricao_en(data.detail[0].descricao_en);
      setDescricao_esp(data.detail[0].descricao_esp);
      Setvalor_esp(data.detail[0].valor_esp);
      setValor_eng(data.detail[0].valor_eng);
      setEmpresa(data.detail[0].empresa);
      setFilialp(data.detail[0].filialp);
      setNome(data.detail[0].nome);
    }
  }, []);

  const handleSubmit = async () => {
    setLoading(true);

    const filial = filialp == "  " ? "01" : filialp;

    const tenantId = empresa + "," + filial;

    

    if (
      valor == "" ||
      valor_eng == "" ||
      valor_esp == "" ||
      descricao == "" ||
      descricao_en == "" ||
      descricao_esp == ""
    ) {
      setMessageError("Preencha todos os campos");
      setLoading(false);
      return;
    }
    const data = {
      nome,
      valor,
      valor_eng,
      valor_esp,
      descricao,
      descricao_esp,
      descricao_en,
      tipo,
      empresa,
      filialp,
      tenantId,
    };

    try {
      const updateParams = await ParamsControlService.updateParam(data);
      console.log(updateParams)
      setLoading(false);
      openNotificationWithIcon("success");
      refreshParent();
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    setLoading(false);
  };

  return (
    <>
      {contextHolder}
      <Col>
        <Row justify={"space-evenly"} style={{ paddingTop: "1%" }}>
          <Col span={5}>
            <Col>{"Nome do Parâmetro"}</Col>
            <Col>
              <Input
                style={{ borderWidth: 3, color: "black" }}
                value={data != {} ? data.detail[0].nome : ""}
                disabled
              />
            </Col>
          </Col>
          <Col span={5}>
            <Col>{"Empresa"}</Col>
            <Col>
              <Input
                style={{ borderWidth: 3, color: "black" }}
                value={data != {} ? data.detail[0].empresa : ""}
                disabled
              />
            </Col>
          </Col>
          <Col span={5}>
            <Col>{"Tipo"}</Col>
            <Col>
              <Input
                style={{ borderWidth: 3, color: "black" }}
                value={tipo ?? ""}
                onChange={(e) => setTipo(e.target.value)}
              />
            </Col>
          </Col>
        </Row>
        <Row justify={"space-evenly"} style={{ paddingTop: "1%" }}>
          <Col span={5}>
            <Col>{"Descrição"}</Col>
            <Col>
              <Input
                style={{ borderWidth: 3, color: "black" }}
                value={descricao ?? ""}
                onChange={(e) => setDescricao(e.target.value)}
              />
            </Col>
          </Col>
          <Col span={5}>
            <Col>{"Descrição Inglês"}</Col>
            <Col>
              <Input
                style={{ borderWidth: 3, color: "black" }}
                value={descricao_en ?? ""}
                onChange={(e) => setDescricao_en(e.target.value)}
              />
            </Col>
          </Col>
          <Col span={5}>
            <Col>{"Descrição Espanhol"}</Col>
            <Col>
              <Input
                style={{ borderWidth: 3, color: "black" }}
                value={descricao_esp ?? ""}
                onChange={(e) => setDescricao_esp(e.target.value)}
              />
            </Col>
          </Col>
        </Row>
        <Row justify={"space-evenly"} style={{ paddingTop: "1%" }}>
          <Col span={5}>
            <Col>{"Valor"}</Col>
            <Col>
              <Input
                style={{ borderWidth: 3, color: "black" }}
                value={valor ?? ""}
                onChange={(e) => setValor(e.target.value)}
              />
            </Col>
          </Col>
          <Col span={5}>
            <Col>{"Valor inglês"}</Col>
            <Col>
              <Input
                style={{ borderWidth: 3, color: "black" }}
                value={valor_eng ?? ""}
                onChange={(e) => setValor_eng(e.target.value)}
              />
            </Col>
          </Col>
          <Col span={5}>
            <Col>{"Valor Espanhol"}</Col>
            <Col>
              <Input
                style={{ borderWidth: 3, color: "black" }}
                value={valor_esp ?? ""}
                onChange={(e) => Setvalor_esp(e.target.value)}
              />
            </Col>
          </Col>
        </Row>
        <Col>
          <Row></Row>
          <Row justify={"center"} style={{ marginTop: "3%" }}>
            {loading ? (
              <Button
                disabled
                onClick={handleSubmit}
                style={{ width: "200px", height: "50px" }}
              >
                Salvar
              </Button>
            ) : (
              <Button
                onClick={handleSubmit}
                style={{ width: "200px", height: "50px" }}
              >
                Salvar
              </Button>
            )}
          </Row>
          <Col
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              justifyItems: "center",
              alignItems: "center",
              paddingTop: "1%",
            }}
          >
            <Row>
              <p style={{ color: "red" }}>{messageError ?? ""}</p>
            </Row>
          </Col>
        </Col>
      </Col>
    </>
  );
}
export default ModalParams;
